/* This component CREATES a Pilot - Cohort - Source table for the pilotcohortsource collection in MongoDB. */

import React, { useEffect, useState }           from 'react'
import axios                                    from 'axios'
import Box                                      from "@material-ui/core/Box"
import {
   Button,
   Grid,
   TextField,
   TextareaAutosize,
   Typography }                                 from '@material-ui/core'
import HistoryCitationComponent                 from './HistoryCitationComponent'
import HistoryReadComponent                     from './HistoryReadComponent'
import PhotoSearchComponent                     from './PhotoSearchComponent'
import RadioOptionComponent                     from '../Components/RadioOptionComponent'

import {
   CLIENT_PUBLIC_TOKEN,
   historyEntryTypeRadioOptions,
   historyRadioOptions
}                                               from '../config'

import { node_server }                          from '../Helpers'
import GuestBioSearchComponent                  from './GuestBioSearchComponent'

const PilotCohortSourceCreateComponent = () => {

   const [ id,                setId                   ]  =  useState('')
   const [ cohort,            setCohort               ]  =  useState('')
   const [ columnOneWidth,    setColumnOneWidth       ]  =  useState('')
   const [ columnTwoWidth,    setColumnTwoWidth       ]  =  useState('')
   const [ columnThreeWidth,  setColumnThreeWidth     ]  =  useState('')
   const [ pilotName,         setPilotName            ]  =  useState('')
   const [ post,              setPost                 ]  =  useState(true)
   const [ source,            setSource               ]  =  useState('')

   const changeColumnOneWidth = (e) => {
      setColumnOneWidth(e.target.value)
   }

   const changeColumnTwoWidth = (e) => {
      setColumnTwoWidth(e.target.value)
   }

   const changeColumnThreeWidth = (e) => {
      setColumnThreeWidth(e.target.value)
   }

   const changeCohort = (e) => {
      setCohort(e.target.value)
   }

   const changePilotName = (e) => {
      setPilotName(e.target.value)
   }

   const changeSource = (e) => {
      setSource(e.target.value)
   }

   const handleSubmit = () => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      if (post) {
         axios.post(node_server + 'pilotCohortSourceTable', {
            columnOneWidth,
            columnTwoWidth,
            columnThreeWidth,
            cohort,
            pilotName,
            source
         })
            .then( res => res.data )
            .then( data => {
               setPost(false)
               setCohort('')
               setPilotName('')
               setSource('')
               setId(data.pilotCohortSourceTableToDB._id)
            } )
            .catch( (error) => {
               console.error(error)
            } )
      }
      else {
         axios.put(node_server + 'pilotCohortSourceTable', {
            id,
            cohort,
            pilotName,
            source
         })
            .then( res => res.data )
            .then( data => {
               setCohort('')
               setPilotName('')
               setSource('')
            } )
            .catch( (error) => {
               console.error(error)
            } )
      }
   }

   return (
      <Grid>
         {Number(columnOneWidth) > 9 && Number(columnTwoWidth) > 9 && Number(columnThreeWidth) > 9
            ?
               <Grid container justifyContent='center' style={{marginTop: '1rem'}} >
                  <Grid item xs={12} >
                     <TextField name='pilot-cohort-source-table-name' label="Pilot Name" variant='outlined' style={{ width: '90%' }} onChange={changePilotName} value={pilotName} autoFocus={true} />
                  </Grid>
                  <Grid item xs={12} style={{marginTop: '1rem'}} >
                     <TextField name='pilot-cohort-source-table-cohort' label="Cohort" variant='outlined' style={{ width: '90%' }} onChange={changeCohort} value={cohort} />
                  </Grid>
                  <Grid item xs={12} style={{marginTop: '1rem'}} >
                     <TextField name='pilot-cohort-source-table-source' label="Source" variant='outlined' style={{ width: '90%' }} onChange={changeSource} value={source} />
                  </Grid>
                  {cohort === '' && pilotName === '' && source === ''
                     ?
                        <Grid>
                           <Button data-testid='history-create-submit' variant='contained' color='primary' disabled >Submit</Button>
                        </Grid>
                     :
                        <Grid>
                           <Button data-testid='history-create-submit' variant='contained' color='primary' onClick={handleSubmit}>Submit</Button>
                        </Grid>
                  }
               </Grid>
            :
               <Grid container direction='row' justifyContent='center' style={{marginTop: '1rem'}} >
                  <Grid item xs={3} >
                     <TextField name='pilot-cohort-source-table-column-one-width' label="Column One Width (%)" variant='outlined' style={{ width: '90%' }} onChange={changeColumnOneWidth} value={columnOneWidth} autoFocus={true} />
                  </Grid>
                  <Grid item xs={3} >
                     <TextField name='pilot-cohort-source-table-column-two-width' label="Column Two Width (%)" variant='outlined' style={{ width: '90%' }} onChange={changeColumnTwoWidth} value={columnTwoWidth} />
                  </Grid>
                  <Grid item xs={3} >
                     <TextField name='pilot-cohort-source-table-column-three-width' label="Column Three Width (%)" variant='outlined' style={{ width: '90%' }} onChange={changeColumnThreeWidth} value={columnThreeWidth} />
                  </Grid>
               </Grid>
         }
      </Grid>
   )
}

export default PilotCohortSourceCreateComponent
